var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVolume24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M16 17.659a6.002 6.002 0 0 0 0-11.317V5.29a7.003 7.003 0 0 1 0 13.42v-1.05Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "m7.284 8.398.216-.03.184-.119L13 4.832v14.336l-5.316-3.417-.184-.118-.216-.031-2.855-.408A.5.5 0 0 1 4 14.699V9.301a.5.5 0 0 1 .43-.495z"
})));
export default SvgVolume24;